export default __webpack_public_path__ + "static/media/CreerUnJeu-2.d5bcdc79.png";